export default {
  LOGIN: "Login",
  SIGN_UP: "Sign up",
  SIGN_UP_NO_REFERENCE: "Sign up no reference",
  SELECT_SIGN_UP: "Select sign up",
  RECOVER: "Recover",
  SET_PASSWORD: "Set password",
  WALLET: "Wallet",
  TOPUP: "Top up",
  TOKENS: "Tokens",
  CATEGORIES: "Categories",
  TRANSACTION: "Transaction",
  TRANSACTIONS: "Transactions",
  BALANCE_REFUND: "Balance refund",
  PAYMENT_METHOD: "Payment method",
  PAYLANDS: "Card payment",
  MERCADOPAGO: "Mercado Pago payment",
  PAYMENT_FRAME: "Complete payment",
  PAYMENT_SUCCESS: "Payment success",
  PAYMENT_ERROR: "Payment error",
  NOT_FOUND: "Not found",
  PAYMENT_RESULT: "Payment result",
  MY_ACCOUNT: "My account",
  QR: "Qr view",
  RECHARGE: "Recharge",
  RECHARGE_PAYMENT: "Recharge payment",
  USER: "User",
  CHANGE_PASSWORD: "Change password",
  SUCCESS_VIEW: "Success view",
  SUCCESS_VIEW_SIGN_UP: "Success view sign up",
  VALIDATE_TAG_OR_TICKET: "Validate tag or ticket",
  DISCOUNT_COUPON: "Discount coupon",
};
